
import classNames from 'classnames';
import React from 'react';
import AppendToBody from 'sharedreact/components/AppendToBody';
import TooltipZIndexContext from 'sharedreact/contexts/TooltipZIndexContext';

type Props = {
  show: boolean;
  title?: string;
  className?: string;
  placement?: string;
  parent: HTMLElement | null;
};

type State = {
  hideToolTip: boolean
};

class Tooltip extends React.Component<Props, State> {
  showTooltipTimer: NodeJS.Timeout | null;  

  static contextType = TooltipZIndexContext;
  context!: React.ContextType<typeof TooltipZIndexContext>;

  _divElement: HTMLDivElement | null;

  constructor (props: Props) {
    super(props);

    this.state = {
      hideToolTip: false
    };

    this._divElement = null;

    this.showTooltipTimer = null;

    this.handleResize = this.handleResize.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.hideTooltip = this.hideTooltip.bind(this);
    this.showTooltip = this.showTooltip.bind(this);
  }

  hideTooltip () {
    if (!this.state.hideToolTip) {
      this.setState({hideToolTip: true});
    }
  }

  showTooltip () {
    if (this.state.hideToolTip) {
      this.setState({hideToolTip: false});
    }
  }

  handleResize () {
    if (this.showTooltipTimer != null) {
      clearTimeout(this.showTooltipTimer);
    }

    if (this.props.show) {
      this.hideTooltip();
      this.showTooltipTimer = setTimeout(this.showTooltip, 200);
    }
  }

  handleScroll () {
    if (this.showTooltipTimer != null) {
      clearTimeout(this.showTooltipTimer);
    }

    if (this.props.show) {
      this.hideTooltip();
      this.showTooltipTimer = setTimeout(this.showTooltip, 200);
    }
  }

  override componentDidMount (): void {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('scroll', this.handleScroll, true);
  }

  override componentDidUpdate (): void {
    const { placement, parent } = this.props;

    if (this._divElement != null) {
      const boundingBox = parent?.getBoundingClientRect();
      let top = 0;
      let left = 0;

      if (boundingBox != null) {
        if (placement?.includes('right')) {
          top = boundingBox.top + (boundingBox.height / 2) - (27 / 2);
          left = boundingBox.right + 5;
        } else if (placement?.includes('bottom')) {
          top = boundingBox.bottom + 5;
          left = boundingBox.left;
        }
      }

      this._divElement.style.top = top + 'px';
      this._divElement.style.left = left + 'px';
    }
  }

  override componentWillUnmount (): void {
    document.removeEventListener('scroll', this.handleScroll, true);
    window.removeEventListener('resize', this.handleResize);
  }

  render () {
    const { show, title, className, placement, parent } = this.props;

    const tooltipZIndex = this.context;

    if (show && !this.state.hideToolTip) {
      const boundingBox = parent?.getBoundingClientRect();

      let top = 0;
      let left = 0;

      if (boundingBox != null) {
        if (placement?.includes('right')) {
          top = boundingBox.top + (boundingBox.height / 2) - (27 / 2);
          left = boundingBox.right + 5;
        } else if (placement?.includes('bottom')) {
          top = boundingBox.bottom + 5;
          left = boundingBox.left;
        }
      }
      const placementClassNames = placement != null ? placement.split(' ').map(part => 'esko_' + part).join(' '): undefined;
  
      return (
        <AppendToBody>
          <div ref={(div) => this._divElement = div} className={classNames('esko_tooltip', className, placementClassNames)} style={{top: top, left: left, zIndex: tooltipZIndex}} role='tooltip'>
            <div className='esko_tooltip-arrow esko_errortooltip-arrow' />
            <div className='esko_tooltip-inner esko_errortooltip-inner'>{title}</div>
          </div>
        </AppendToBody>
      );
    }

    return undefined;
  }
}

Tooltip.contextType = TooltipZIndexContext;


export default Tooltip;